import React from 'react';
import { Context } from '../model/elements';

const CustomContext: React.Context<Context> = React.createContext({
    updateAuth: () => {},
});
export default CustomContext;
